import type { FacilitySection, Hotel } from '~~/domains/graphql';

export function useHotelFacilities(hotel: Ref<Hotel | null | undefined>) {
  return computed(
    () => (hotel?.value?.hotelFacilities || []) as FacilitySection[],
  );
}
